import Chip from "@mui/material/Chip";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { useTranslationApp } from "../../lib/i18next";
import {
  getCampaignApprovalStatusLabel,
  getCampaignApprovalStatusSx,
} from "../../pages/CampaignApproval/utils";

const ContentApprovalStatusChip = ({ status, size = "small", label = "" }) => {
  const { t } = useTranslationApp();

  if (!status) {
    return null;
  }

  const statusSx = getCampaignApprovalStatusSx(status);
  const isSmall = size === "small";

  return (
    <Chip
      icon={
        status === "pending" ? (
          <AccessTimeIcon sx={{ fontSize: isSmall ? 10 : 12 }} />
        ) : undefined
      }
      label={label || getCampaignApprovalStatusLabel(status, t)}
      size="small"
      sx={{
        height: isSmall ? 20 : 24,
        fontSize: isSmall ? "0.6rem" : "0.65rem",
        fontWeight: 700,
        letterSpacing: "0.25px",
        textTransform: "uppercase",
        bgcolor: statusSx.bgcolor,
        border: "1px solid",
        borderColor: statusSx.borderColor,
        color: statusSx.color,
        "& .MuiChip-label": { px: isSmall ? 0.75 : 1 },
        "& .MuiChip-icon": {
          color: statusSx.color,
          ml: 0.5,
          mr: -0.25,
        },
      }}
    />
  );
};

export default ContentApprovalStatusChip;
